import React, { useEffect } from 'react';

let toastTimeout;

export default function AlertToast({ message, type = 'success', show, onClose }) {
  useEffect(() => {
    if (show) {
      clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => { if (onClose) onClose(); }, 4000);
    }
    return () => clearTimeout(toastTimeout);
  }, [show, onClose]);

  if (!show || !message) return null;

  const icons = { success: 'bi-check-circle-fill', danger: 'bi-x-circle-fill', warning: 'bi-exclamation-triangle-fill', info: 'bi-info-circle-fill' };

  return (
    <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, minWidth: 300 }}>
      <div className={`alert alert-${type} alert-dismissible d-flex align-items-center shadow`} role="alert">
        <i className={`bi ${icons[type] || icons.info} me-2`}></i>
        <div style={{ flex: 1, fontSize: 13 }}>{message}</div>
        <button type="button" className="btn-close btn-close-sm ms-2" onClick={onClose}></button>
      </div>
    </div>
  );
}
